import React, { useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useForm, useWatch } from 'react-hook-form';
import SingleDatePicker from '../../../components/form/SingleDatePicker';

const BulkPDFJobsFilters = ({ onbulkpdfdownload, isLoading }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      startDate: null,
      endDate: null,
    },
  });
  const startDate = useWatch({ control, name: 'startDate' });
  const endDate = useWatch({ control, name: 'endDate' });

  const canGenerate = useMemo(() => !!startDate && !!endDate, [startDate, endDate]);

  const handleGenerate = (data) => {
    const formattedData = {
      ...data,
      startDate: data.startDate ? data.startDate.format('YYYY-MM-DD') : null,
      endDate: data.endDate ? data.endDate.format('YYYY-MM-DD') : null,
    };
    onbulkpdfdownload(formattedData);
    reset();
  };
  return (
    <form onSubmit={handleSubmit(handleGenerate)}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid container spacing={2} size={10} justifyContent="flex-start">
          <Grid item xs={12} sm={4}>
            <SingleDatePicker
              control={control}
              name="startDate"
              label="Start Date"
              errors={errors}
              minDate={endDate ? endDate.subtract(1, 'year') : null}
              maxDate={endDate && endDate.isBefore(dayjs()) ? endDate : dayjs()}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <SingleDatePicker
              control={control}
              name="endDate"
              label="End Date"
              errors={errors}
              minDate={startDate ? startDate : null}
              maxDate={startDate && startDate.add(1, 'year').isBefore(dayjs()) ? startDate.add(1, 'year') : dayjs()}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={3} container justifyContent="flex-end" alignItems="center">
          <Button
            id="bulk-pdf-download"
            type="submit"
            variant="contained"
            fullWidth
            disabled={!canGenerate || isLoading}
          >
            {isLoading ? 'Generating...' : 'Bulk Download PDFs'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default BulkPDFJobsFilters;
